import React, { useState, useEffect } from 'react';
import { Box, Typography, ThemeProvider } from '@mui/material';
import { Grid, Button, Menu, IconButton } from '@mui/material';
import getTheme from '../../theme/theme';
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { ARROW } from "../../constants/Common"
import { toast } from 'react-toastify';
import axios from 'axios';

//import ProjectScheduleEdit from './ProjectScheduleEdit';
import ProjectGanttCalendar from './ProjectGanttCalendar';
import { Projects } from './ProjectInterfaces';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import ProjectScheduleEdit2 from './ProjectScheduleEdit2';
import { GanttTask } from './ProjectInterfaces';
import { Activity } from './ProjectInterfaces';
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { BASEURL } from "../../constants/Common"

const ProjectScheduleView: React.FC = () => {
    const [selProjects, setSelProjects] = useState<Projects[]>([]);
    const location = useLocation();
    const [tasks, setTasks] = React.useState<GanttTask[]>([]);  //for gantt chart
    const [tasksArray, setTasksArray] = React.useState<GanttTask[][]>([]);
    const [selChartView, setSelChartView] = useState<boolean>(true); // State to view chart or calendar view mode

    const [activityData, setActivityData] = useState<Activity[]>([]);
    const [activityDataArray, setActivityDataArray] = useState<Activity[][]>([]);
    const [sourceProjectCode, setSourceProjectCode] = useState<string>('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [sourceIndex, setSourceIndex] = useState<number>(0);
    const [targetIndex, setTargetIndex] = useState<number>(0);
    const orgid = localStorage.getItem('orgid');


    useEffect(() => {
        let l_selectedProject = location?.state?.selectedProjects;
        if (l_selectedProject !== undefined) {
            setSelProjects(l_selectedProject)
        }
    }, []);

    const projectname = selProjects.map(project=>(project.project_name));
    const projectcode = selProjects.map(project=>(project.project_code));

    console.log("projectname:",projectname);

    const copySchedule = (sourceIndex: number) => {
        setTasks(tasksArray[sourceIndex]);
        setActivityData(activityDataArray[sourceIndex]);

        if (activityDataArray[sourceIndex].length > 0) {
            setSourceProjectCode(activityDataArray[sourceIndex][0].project_code);
        }
        setSourceIndex(sourceIndex)
    }

    const pasteSchedule = () => {
        const TargetProjectCode = getProjectCode(targetIndex);
        setTasksArray(prevTasksArray => {
            const newTasksArray = [...prevTasksArray];
            newTasksArray[targetIndex] = [...tasks]; // Use spread to avoid reference issues            
            return newTasksArray;
        });

        setActivityDataArray(prevActivityArray => {
            const newActivityArray = [...prevActivityArray];
            newActivityArray[targetIndex] = [...activityData]; // Use spread to avoid reference issues            
            return newActivityArray;
        });

        const updatedTasks = updateTaskNamePrefix(tasks, sourceProjectCode, TargetProjectCode);

    }

    const updateTaskNamePrefix = (tasks: GanttTask[], oldPrefix: string, newPrefix: string): GanttTask[] => {
        return tasks.map(task => {
            // Update the TaskName

            if (task.TaskName.startsWith(oldPrefix)) {
                task.TaskName = task.TaskName.replace(oldPrefix, newPrefix);
            }
      
            // Recursively update subtasks
            if (task.subtasks && task.subtasks.length > 0) {
                task.subtasks = updateTaskNamePrefix(task.subtasks, oldPrefix, newPrefix);
            }

            return task;
        });
    };
    const getProjectCode = (index: number): string => {
        if (index >= 0 && index < selProjects.length) {
            return selProjects[index].project_code;
        }
        return '';
    };


    const getSelProjectIds = (): string => {
        let projectIds = '';
        let index = 0;
        for (; index < selProjects.length; index++) {
            if(index === 0)
                projectIds = selProjects[index].id +"";
            else
                projectIds = projectIds + ',' + selProjects[index].id;
        }
        return projectIds;
    };

    const handlePasteSchedule = (targetIndex: number) => {
        setTargetIndex(targetIndex)
        setConfirmOpen(true);
    }



    const setActivityForProject = (index: number, newActivity: Activity[]) => {
        setActivityDataArray(prevActivityArray => {
            const newActivityArray = [...prevActivityArray];
            newActivityArray[index] = newActivity;
            return newActivityArray;
        });
    };

    const setTasksForProject = (index: number, newTasks: GanttTask[]) => {
        setTasksArray(prevTasksArray => {
            const newTasksArray = [...prevTasksArray];
            newTasksArray[index] = newTasks;
            return newTasksArray;
        });
    };


    const handleConfirmClose = async (confirmed: boolean) => {
        setConfirmOpen(false);
        // Handle OK/Cancel actions here based on the 'confirmed' value to paste schedule
        if (confirmed) {
            pasteSchedule();

            const payload = {
                source_projectid: selProjects[sourceIndex].id,
                target_projectid: selProjects[targetIndex].id,
            }

            const create_url = BASEURL + '/projects/copy-activities/';
            let response = await axios.post(create_url, payload,
                { headers: { 'Content-Type': 'multipart/form-data', }, }
            );

            if (!response.data.success) {
                toast.error(response.data.message)
                return
            }
            else
                toast.info("The copied project tasks are pasted and saved to db.")

        }
    };


    const showCalendarView = () => {
        setSelChartView((prevViewMode) => !prevViewMode);
    }


    return (

        <ThemeProvider theme={getTheme()}>
            <div>

                <Box sx={{ marginTop: '-5%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant='h6' gutterBottom>
                            <Link to={'/projectschedule'} >Project Schedule</Link>{ARROW} View Schedule
                        </Typography>

                        <Box sx={{ marginLeft: 'auto' }}>
                            <Button variant="contained" onClick={() => showCalendarView()}>
                                {selChartView ? 'Calendar View' : 'Chart View'}
                            </Button>
                        </Box>

                    </Box>
                </Box>

                {confirmOpen ?
                    <ConfirmationDialog confirmOpen={confirmOpen} title="Confirm Paste"
                        message="Are you sure you want to paste these activities to the schedule? " onClose={handleConfirmClose} />
                    : (null)}

                {/*
                {selProjects.map((project: Projects, index: number) => (
                    <div key={project.id}>
                        <Typography variant="h5" gutterBottom sx={{ mt: index === 0 ? '2%' : '4%' }}>
                            {project.project_name}
                        </Typography>

                        <ProjectScheduleEdit arg_projectid={project.id ? project.id : -1}
                            arg_projectcode={project.project_code ? project.project_code : ''}></ProjectScheduleEdit>
                    </div>
                ))}

*/}

                {selChartView ? (
                    <div>
                        {
                            selProjects.map((project: Projects, index: number) => (
                                <div key={project.id}>

                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={4}>
                                            <Typography variant="h5" gutterBottom sx={{ mt: index === 0 ? '2%' : '4%' }}>
                                                {project.project_name}
                                            </Typography>
                                        </Grid>

                                        {selProjects.length > 1 ? (
                                            <Grid item xs={8}>
                                                <Grid container spacing={2} justifyContent="center">
                                                    <Grid item>
                                                        <Button variant="contained" onClick={() => copySchedule(index)}>
                                                            Copy Schedule
                                                        </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button variant="contained" onClick={() => handlePasteSchedule(index)}>
                                                            Paste Schedule
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        ) : (null)}
                                    </Grid>
                                    
                                    <ProjectScheduleEdit2
                                        arg_projectid={project.id ? project.id : -1}
                                        arg_projectcode={project.project_code ? project.project_code : ''}
                                        arg_projectname={project.project_name ? project.project_name : ''}
                                        project_startdate={project.project_start_date} // Pass the start date here
                                        project_enddate={project.project_end_date}
                                        project_empolyees={project.employees}
                                        project_contractors={project.contractors}
                                        activityData={activityDataArray[index] || []}
                                        setActivityData={(newActivity: Activity[]) => setActivityForProject(index, newActivity)}
                                        tasks={tasksArray[index] || []}
                                        setTasks={(newTasks: GanttTask[]) => setTasksForProject(index, newTasks)}
                                    />

                                </div>
                            ))
                        } </div>
                ) : (<div>
                    <ProjectGanttCalendar project_ids={getSelProjectIds()} orgid={orgid} projectname={projectname} projectcode={projectcode} ></ProjectGanttCalendar>
                </div>)
                }
                < FloatingButton />
            </div >
        </ThemeProvider >
    );
};

export default ProjectScheduleView;